if (!window.Eurus.loadedScript.includes('preview-color-swatches.js')) {
  window.Eurus.loadedScript.push('preview-color-swatches.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xProductCard', (
        sectionId,
        productUrl,
        productId,
      ) => ({
        currentVariantCard: '',
        options: [],
        isSelect: false,
        productId: productId,
        showOptions: false,
        init() {          
          document.addEventListener(`eurus:product-card-variant-select:updated:${sectionId}`, (e) => {
            this.checkVariantSelected();
            this.currentVariantCard = e.detail.currentVariant;
            this.options = e.detail.options;
          });
        },
        checkVariantSelected() {
          const fieldset = [...document.querySelectorAll(`#variant-update-${sectionId} fieldset`)];
          if(fieldset.findIndex(item => !item.querySelector("input:checked")) == "-1") {
            this.isSelect = true;
          }
        }
      }))

      Alpine.store('xPreviewColorSwatch', {
        onChangeVariant(el, productUrl, src, variantId, sectionId, isColor = false) {
          document.addEventListener(`eurus:product-card-variant-select:updated:${sectionId}`, (e) => {
            if (e.detail.currentVariant == null) {
              this.updateImage(el, productUrl, src, variantId, sectionId);
            }
          });

          if (!isColor) {
            let productVariants = ''

            document.dispatchEvent(new CustomEvent(`eurus:product-variant-get:${sectionId}`, {
              detail: {
                callback: (variants) => {
                  productVariants = variants;
                }
              }
            }));

            if (productVariants) {
              let variantSrc = productVariants.reduce((acc, variant) => {
                if (variant.featured_image) {
                  acc[variant.id] = variant.featured_image.src;
                }
                return acc;
              }, {});
      
              const swatchesContainer = el.closest('.options-container');
              if (swatchesContainer) {
                const swatches = swatchesContainer.querySelectorAll('label.color-watches');
                const inputs = swatchesContainer.querySelectorAll('input:checked');
    
                let selectedOption = [];
    
                inputs.forEach(input => { 
                  if (![...swatches].some(swatch => swatch.dataset.optionvalue === input.value)) {
                    selectedOption.push(input.value);
                  }
                });
    
                let imageSrc = productVariants
                  .filter(variant => selectedOption.every(option => variant.options.includes(option)))
                  .map(variant => `url(${variantSrc[variant.id] ? variantSrc[variant.id] : src})`);
                
                swatches.forEach((swatch, index) => {
                  swatch.style.setProperty('--bg-image',  imageSrc[index]);
                });
              }
            }
          } 
        },

        updateImage(el, productUrl, src, variantId, sectionId, hasVariant) {
          const cardProduct = el.closest('.card-product');
          let getLink =  productUrl + `?variant=${variantId}`;
          if (!cardProduct) return;
          const linkVariant = cardProduct.getElementsByClassName("link-product-variant");
          for (var i = 0; i < linkVariant.length; i ++) {
            linkVariant[i].setAttribute("href", getLink);
          }
          const currentVariant = cardProduct.querySelector(".current-variant");
          if (currentVariant && !hasVariant) {
            currentVariant.innerText = variantId;
          }

          if (src != '') {
            let media = cardProduct.querySelector(`[media="${src}"]`);
            if (media) {
              let index = media.getAttribute('index');
              let slide = cardProduct.querySelector('.x-splide');
              if (slide) {
                if (slide.splide) {
                  slide.splide.go(Number(index));
                } else {
                  document.addEventListener(`eurus:${sectionId}:splide-ready`, () => {
                    slide.splide.go(Number(index));
                  });
                }
                return;
              } 
            }
            const previewImg = cardProduct.getElementsByClassName("preview-img")[0];
            if (!previewImg) return;
            previewImg.removeAttribute("srcset");
            previewImg.setAttribute("src", src);
            let slide = cardProduct.querySelector('.x-splide');
            if (slide && slide.splide) {
              slide.splide.go(0);
            }
          } else {
            let slide = cardProduct.querySelector('.x-splide');
            if (slide && slide.splide) {
              slide.splide.go(0);
            }
          }
        },

        updateQuickAdd(productUrl, variantId, quickAddPageParam, productId, targetFormProductId, isAvailable = true, clickedElement = null){
          // Find the card product from the clicked element
          const cardProduct = clickedElement ? clickedElement.closest('.card-product') : null;

          // Find the form within this specific card (not by ID matching)
          const cardForm = cardProduct ? cardProduct.querySelector('form[id^="product-form-choose-option"]') : null;

          console.log('=== updateQuickAdd DEBUG ===');
          console.log('variantId:', variantId);
          console.log('isAvailable:', isAvailable);
          console.log('Card product found:', !!cardProduct);
          console.log('Card form found:', !!cardForm, cardForm?.id);

          if(cardForm && variantId){
            // Directly update the variant ID in the form
            const variantInput = cardForm.querySelector('input[name="id"]');
            if(variantInput){
              console.log('Variant input value BEFORE:', variantInput.value);
              variantInput.value = variantId;
              console.log('Variant input value AFTER:', variantInput.value);
            }

            // Update the current-variant display element
            const currentVariantEl = cardProduct.querySelector('.current-variant');
            if(currentVariantEl){
              currentVariantEl.textContent = variantId;
            }

            // Fetch the new product data for price/button updates
            let url = `${productUrl}?variant=${variantId}&section_id=choose-option&page=${quickAddPageParam}`
            fetch(url)
            .then((response) => response.text())
            .then((responseText) => {
              const html = new DOMParser().parseFromString(responseText, 'text/html');

              // Update price
              const currentPrice = cardProduct.querySelector(".main-product-price");
              const updatePrice = html.querySelector(".main-product-price");
              if(currentPrice && updatePrice){
                currentPrice.innerHTML = updatePrice.innerHTML;
              }

              // Update variant options (size swatches) for combined listings
              const currentOptions = cardProduct.querySelector(".options-container");
              const sourceOptions = html.querySelector(".options-container");
              if(currentOptions && sourceOptions && targetFormProductId){
                const currentFieldsets = currentOptions.querySelectorAll('fieldset:not([data-swatch="true"])');
                const sourceFieldsets = sourceOptions.querySelectorAll('fieldset:not([data-swatch="true"])');
                if(currentFieldsets.length > 0 && sourceFieldsets.length > 0){
                  currentFieldsets.forEach((fieldset, index) => {
                    if(sourceFieldsets[index]){
                      fieldset.innerHTML = sourceFieldsets[index].innerHTML;
                    }
                  });
                }
              }

              // Update add-to-cart button based on availability
              const currentButton = cardForm.querySelector('button[type="submit"][name="add"]');
              const sourceButton = html.querySelector('button[type="submit"][name="add"]');
              if(currentButton){
                const isSourceDisabled = sourceButton?.hasAttribute('disabled');
                if(isSourceDisabled || !isAvailable){
                  currentButton.setAttribute('disabled', 'disabled');
                  currentButton.classList.add('opacity-60', 'cursor-not-allowed');
                  if(sourceButton){
                    const sourceSpan = sourceButton.querySelector('span:first-child');
                    const currentSpan = currentButton.querySelector('span:first-child');
                    if(sourceSpan && currentSpan) currentSpan.innerHTML = sourceSpan.innerHTML;
                  }
                } else {
                  currentButton.removeAttribute('disabled');
                  currentButton.classList.remove('opacity-60', 'cursor-not-allowed');
                  if(sourceButton){
                    const sourceSpan = sourceButton.querySelector('span:first-child');
                    const currentSpan = currentButton.querySelector('span:first-child');
                    if(sourceSpan && currentSpan) currentSpan.innerHTML = sourceSpan.innerHTML;
                  }
                }
              }
            })
          }
        }
      });
    })
  });
}    